var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"folder-caret gl-display-inline-block gl-text-secondary gl-w-5 gl-mr-2"},[_c('gl-icon',{attrs:{"size":12,"name":_vm.iconClass}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }